/**
 * Used when building consultation / save payloads. Returns only panels where
 * at least one test has a non-empty value, and each test as the legacy shape
 * { test, code, value, unit } (no UI-only fields).
 */
export function filterInitialObservationForClinicalPayload(panelData) {
  if (!Array.isArray(panelData)) return [];

  const hasEnteredValue = (test) =>
    test?.value != null && String(test.value).trim() !== "";

  return panelData
    .filter((panel) => (panel.tests || []).some(hasEnteredValue))
    .map((panel) => ({
      panel_name: panel.panel_name,
      tests: (panel.tests || [])
        .filter(hasEnteredValue)
        .map((t) => ({
          test: t.test,
          code: t.code,
          value: t.value,
          unit: t.unit,
        })),
    }));
}
